import { JSConn } from "@/utilities/js-conn";
import api from "@/api";
import store, { StoreActions } from "@/store";
import { TruckLoadReportApiParams } from "@/models/TruckLoadReport";

const itemDetails = {
  pluralName: "truck_load_reports",
  singularName: "truck_load_report",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  const formParams = jsConn.formParams as TruckLoadReportApiParams;

  return {
    truck_load_report: {
      ...formParams,
    } as TruckLoadReportApiParams,
  };
};

async function needTruckLoadReport(jsConn: JSConn) {
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    return store.dispatch(StoreActions.loadTruckLoadReport, jsConn.response);
  });
}

async function createTruckLoadReport(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api.createItem(jsConn, itemDetails).then((jsConn: JSConn) => {
    let tmpValue = { ...jsConn.response };
    return store.dispatch(StoreActions.loadTruckLoadReport, tmpValue);
  });
}

export const truckLoadReportsController = {
  needTruckLoadReport,
  createTruckLoadReport,
};
